/**
 * @class Rgb
 */
export default class Rgb {
    /**
     * @param {Number} red
     * @param {Number} green
     * @param {Number} blue
     */
    constructor(red, green, blue) {
        this._red = red;
        this._green = green;
        this._blue = blue;
        this.setHex(red, green, blue);

        if (typeof this._red !== "number") {
            throw new Error("Invalid datatype of red");
        }

        if (typeof this._green !== "number") {
            throw new Error("Invalid datatype of green");
        }

        if (typeof this._blue !== "number") {
            throw new Error("Invalid datatype of blue");
        }
    }

    /**
     * @return {Number}
     */
    get red() {
        return this._red;
    }

    /**
     * @param {Number} id
     */
    set red(red) {
        this._red = red;
    }

    /**
     * @return {Number}
     */
    get green() {
        return this._green;
    }

    /**
     * @param {Number} green
     */
    set green(green) {
        this._green = green;
    }

    /**
     * @return {Number}
     */
    get blue() {
        return this._blue;
    }

    /**
     * @param {Number} blue
     */
    set blue(blue) {
        this._blue = blue;
    }

    /**
     * @return {Number}
     */
    get hex() {
        return this._hex;
    }

    /**
     * @param {Number} hex
     */
    set hex(hex) {
        try {
            if (hex !== undefined && hex.length === 7) {
                this._red = parseInt(hex.substr(1, 2), 16);
                this._green = parseInt(hex.substr(3, 2), 16);
                this._blue = parseInt(hex.substr(5, 2), 16);
            }

            if (hex !== undefined && hex.length === 4) {
                this._red = parseInt(hex.substr(1, 1) + hex.substr(1, 1), 16);
                this._green = parseInt(hex.substr(2, 1) + hex.substr(2, 1), 16);
                this._blue = parseInt(hex.substr(3, 1) + hex.substr(3, 1), 16);
            }
        } catch (e) {
            this._red = 0;
            this._green = 0;
            this._blue = 0;
        }

        this._hex = hex;
    }

    /**
     * @param   {Number}    colorPart
     * @return  {String}
     */
    hexMe = (colorPart) => {
        let hex = colorPart.toString(16);

        if (colorPart < 16) {
            return "0" + hex;
        }

        return hex;
    };

    /**
     * @param   {Number}    red
     * @param   {Number}    green
     * @param   {Number}    blue
     */
    setHex = (red, green, blue) => {
        this._hex = "#" + this.hexMe(red) + this.hexMe(green) + this.hexMe(blue);
    };

    /**
     * Clones rgb object and updates red property.
     *
     * @param   {Number} red
     * @return  {Object}
     */
    updateRed = (red) => {
        return new Rgb(red, this._green, this._blue);
    };

    /**
     * Clones rgb object and updates green property.
     *
     * @param   {Number} green
     * @return  {Object}
     */
    updateGreen = (green) => {
        return new Rgb(this._red, green, this._blue);
    };

    /**
     * Clones rgb object and updates blue property.
     *
     * @param   {Number} blue
     * @return  {Object}
     */
    updateBlue = (blue) => {
        return new Rgb(this._red, this._green, blue);
    };

    /**
     * Clones rgb object and updates hex property.
     *
     * @param   {String} hex
     * @return  {Object}
     */
    updateHex = (hex) => {
        let rgb = new Rgb(this._red, this._green, this._blue);
        rgb.hex = hex;

        return rgb;
    };
}
